import React from 'react'
import { Ship, Utensils, Sun, Sparkles, HandHeart, Users } from 'lucide-react'

const DEFAULT_HIGHLIGHTS = [
  { key: 'boat',     icon: Ship,     label: 'Charming wooden boat' },
  { key: 'cabin',    icon: Users,    label: '27 spacious luxury cabins' },
  { key: 'cuisine',  icon: Utensils, label: 'Vietnamese & Asian cuisine' },
  { key: 'sundeck',  icon: Sun,      label: 'Spacious sundeck' },
  { key: 'wellness', icon: Sparkles, label: 'Spa & wellness room' },
  { key: 'service',  icon: HandHeart, label: 'Service from the heart' },
]

function resolveHighlights(acfHighlights) {
  if (Array.isArray(acfHighlights)) {
    const repeaterItems = acfHighlights
      .map((item, i) => ({
        icon: DEFAULT_HIGHLIGHTS[i]?.icon ?? Ship,
        label: typeof item === 'object' ? item?.label : item,
      }))
      .filter((item) => String(item.label ?? '').trim())

    return repeaterItems.length ? repeaterItems : DEFAULT_HIGHLIGHTS
  }

  if (acfHighlights && typeof acfHighlights === 'object') {
    const groupItems = DEFAULT_HIGHLIGHTS
      .map(({ key, icon }) => ({
        icon,
        label: acfHighlights[key],
      }))
      .filter((item) => String(item.label ?? '').trim())

    return groupItems.length ? groupItems : DEFAULT_HIGHLIGHTS
  }

  return DEFAULT_HIGHLIGHTS
}

function formatReviewCount(value) {
  const count = Number(value)

  if (!Number.isFinite(count) || count <= 0) return '248'

  return new Intl.NumberFormat('en-US').format(count)
}

// Mock OTA badge — anh thay bằng ảnh thật sau
function OtaBadge({ rating, reviewsCount }) {
  const score = String(rating ?? '').trim() || '8.7'
  const reviews = formatReviewCount(reviewsCount)

  return (
    <div className="sc-ota-badge">
      <svg viewBox="0 0 120 140" fill="none" xmlns="http://www.w3.org/2000/svg" className="sc-ota-badge__svg">
        {/* Shield shape */}
        <path d="M60 4 L112 28 L112 80 C112 110 60 136 60 136 C60 136 8 110 8 80 L8 28 Z"
          fill="#003580" />
        <path d="M60 12 L104 34 L104 80 C104 107 60 130 60 130 C60 130 16 107 16 80 L16 34 Z"
          fill="#0057b8" />
        {/* Stars */}
        <text x="60" y="58" textAnchor="middle" fill="#FFD700" fontSize="18" fontFamily="serif">★★★★⯪</text>
        {/* Score */}
        <text x="60" y="88" textAnchor="middle" fill="white" fontSize="28" fontWeight="bold" fontFamily="sans-serif">{score}</text>
        {/* Label */}
        <text x="60" y="106" textAnchor="middle" fill="rgba(255,255,255,0.85)" fontSize="9" fontFamily="sans-serif" letterSpacing="1">EXCELLENT</text>
      </svg>
      <div className="sc-ota-badge__label">Guest Rating</div>
      <div className="sc-ota-badge__reviews">Based on {reviews} reviews</div>
    </div>
  )
}

export default function Overview({ content, highlights, rating, reviewsCount }) {
  const items = resolveHighlights(highlights)

  return (
    <section className="sc-section">
      {/* Row 1: content + OTA badge */}
      <div className="sc-overview__top">
        <div className="sc-overview__content">
          <h2 className="ljn-section-title">About This Cruise</h2>
          <div className="ljn-divider" />
          {content
            ? <div className="sc-prose" dangerouslySetInnerHTML={{ __html: content }} />
            : (
              <div className="sc-prose">
                <p>Drift through the emerald waters of Halong Bay aboard a vessel that blends the soul of traditional Vietnamese craftsmanship with the comforts of contemporary luxury. Every curve of the wooden hull, every lantern-lit corridor tells a story of the sea.</p>
              </div>
            )
          }
        </div>

        <OtaBadge rating={rating} reviewsCount={reviewsCount} />
      </div>

      {/* Row 2: 6 highlight boxes */}
      <div className="sc-highlights-grid">
        {items.map(({ icon: Icon, label }) => (
          <div key={label} className="sc-highlight-box">
            <div className="sc-highlight-box__icon">
              <Icon size={32} strokeWidth={1.5} />
            </div>
            <span className="sc-highlight-box__label">{label}</span>
          </div>
        ))}
      </div>
    </section>
  )
}
